function updateCardLinksWithVariant(card, variantId) {
  if (!variantId) return;

  const links = card.querySelectorAll('a.link-redirect-to-product');

  links.forEach((link) => {
    if (link.href.includes(card.dataset.productUrl)) {
      const url = new URL(link.href, window.location.origin);
      url.searchParams.set('variant', variantId);
      link.href = url.toString();
    }
  });
}

// `var`, not `const`: this file is included once per card, and a re-declared const throws.
var SRCSET_WIDTHS = [165, 360, 533, 720, 940, 1066];

function buildSrcset(url) {
  return SRCSET_WIDTHS.map((w) => `${url.replace(/width=\d+/, `width=${w}`)} ${w}w`).join(', ');
}

function replaceVariantSlides(card, extras) {
  const track = card.querySelector('[data-carousel-track]');
  if (!track) return;

  // GMS - PLP Carousel: update variant images without the old hover slide.
  track.querySelectorAll('.card-carousel__slide--variant').forEach((slide) => slide.remove());

  const mainImage = track.querySelector('img.main-image');
  if (!mainImage) return;

  const sharedCount = track.querySelectorAll(
    '.card-carousel__slide:not(.main-image):not(.hover-image):not(.card-carousel__slide--variant)'
  ).length;

  const maxSlides = parseInt(track.dataset.maxSlides, 10) || 5;
  const room = maxSlides - 1 - sharedCount;

  const urls = (extras || '')
    .split('|')
    .filter(Boolean)
    .slice(0, Math.max(room, 0));

  let anchor = mainImage;

  urls.forEach((url) => {
    const img = document.createElement('img');

    img.className = 'motion-reduce card-carousel__slide card-carousel__slide--variant';
    img.src = url;
    img.srcset = buildSrcset(url);
    img.sizes = mainImage.sizes;
    img.alt = '';
    img.loading = 'eager';
    img.dataset.carouselSlide = '';

    anchor.after(img);
    anchor = img;
  });
}

function initSwatches(scope = document) {
  scope.querySelectorAll('.swatches').forEach((wrapper) => {
    const swatches = wrapper.querySelectorAll('.swatch');
    if (!swatches) return;
    const card = wrapper.closest('.card-wrapper');
    const mainImage = card.querySelector('.media img.main-image');

    const selected = wrapper.querySelector('.swatch.selected');
    if (selected?.dataset.variantId) {
      updateCardLinksWithVariant(card, selected.dataset.variantId);
    }

    swatches.forEach((swatch) => {
      swatch.addEventListener('click', () => {
        const variantId = swatch.dataset.variantId;
        updateCardLinksWithVariant(card, variantId);

        swatches.forEach((s) => s.classList.remove('selected'));
        swatch.classList.add('selected');

        const mainSrc = swatch.dataset.variantImage;

        if (mainSrc && mainImage) {
          mainImage.src = mainSrc;
          mainImage.srcset = buildSrcset(mainSrc);
        }

        replaceVariantSlides(card, swatch.dataset.variantExtras);

        // The card carousel rebuilds its slides and resets to the first image on this.
        card.dispatchEvent(new CustomEvent('card:variant-change', { detail: { variantId } }));
      });
    });
  });
}

if (!window.cardSwatchesListening) {
  window.cardSwatchesListening = true;
  document.addEventListener('DOMContentLoaded', () => {
    initSwatches();
  });
}
